export default {
  UNPAID: {
    value: 110,
    label: '待付款',
  },
  PAID: {
    value: 111,
    label: '已付款',
  },
}